import { LogLevel, type Transport } from '@littlebird/logger';

import { syncLogContext, syncLogScalars } from './sync-log-fields';

import type { SyncEvent } from '../../../electron/shared/sync-telemetry.types';

const FORWARDED_LEVELS: Partial<Record<LogLevel, SyncEvent['level']>> = {
  [LogLevel.Info]: 'info',
  [LogLevel.Warn]: 'warn',
  [LogLevel.Error]: 'error',
};

export function createSyncAxiomTransport(deps: {
  send: (event: SyncEvent) => void;
  getSyncRequestId: () => string | undefined;
}): Transport {
  return (level, _loggerContext, message, metadata) => {
    const mapped = FORWARDED_LEVELS[level];
    const context = syncLogContext(metadata);
    if (!mapped || !context) return;
    try {
      const flat = syncLogScalars(metadata);
      deps.send({
        level: mapped,
        context: context.slice(0, 80),
        message: (message instanceof Error
          ? message.message
          : String(message)
        ).slice(0, 200),
        sync_request_id: deps.getSyncRequestId(),
        metadata: Object.keys(flat).length > 0 ? flat : undefined,
      });
    } catch {
      // Telemetry must never break the sync path
    }
  };
}
